module.exports = __webpack_public_path__ + "2da26432652d121e2ff7d4d4cc076136.jpg";